import React, { useEffect, useState, useContext } from "react";
import './Legal.css';
import logo from '../../Assest/LogoSingefin.png';
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import { NavLink } from "react-router-dom";
import GroupPerson from '../../Assest/GroupPerson.png'
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";

function Legal() {

    const urlGetLegals = urlApiServer + "legals?populate=*"
    const urlPostLegals = urlApiServer + "legalforms"

    const [name, setName] = useState('')
    const [surnames, setSurnames] = useState('')
    const [currentPosition, setCurrentPosition] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [appointment, setAppointment] = useState('')
    const [explains, setExplains] = useState('')
    const [data, setData] = useState([]);
    const { infoUser } = useContext(LoginContext)

    const loggedInUser = () => {
        Swal.fire({
            title: "Error",
            text: "Ya estas vinculado",
            icon: "error",
            allowOutsideClick: false
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetLegals, requestOptions)
                    .then(response => response.json())
                    .then(LegalResponse => {
                        console.log('info del Legal: ', LegalResponse.data);
                        setData(LegalResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }


        })();

    }, [urlGetLegals]);

    function headleNames(e) {
        setName(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleSurnames(e) {
        setSurnames(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleAppointment(e) {
        setAppointment(e.target.value); // Para un input tipo fecha, usa `value`
    }

    function headleCurrentPosition(e) {
        setCurrentPosition(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headlePhone(e) {
        setPhone(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleEmail(e) {
        setEmail(e.target.value); // Para un input tipo email, usa `value`
    }

    function headleExplains(e) {
        setExplains(e.target.value); // Para un input tipo email, usa `value`
    }

    async function postFormLegal() {
        const dataPost = JSON.stringify({
            data: {
                nombres: name,
                apellidos: surnames,
                fecha_de_la_reunion: appointment,
                cargo_actual: currentPosition,
                telefono: phone,
                correo: email,
                mensaje: explains
            }
        });

        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: 'POST',
            headers: registerHeaders,
            body: dataPost,
            redirect: 'follow'
        };

        await fetch(urlPostLegals, requestOptions)
            .then(response => response.json())
            .then(dataPostResponse => {
                console.log('dataPostResponse', dataPostResponse);
                Swal.fire({
                    title: "Correcto",
                    text: "Haz agendado una cita",
                    icon: "success",
                    allowOutsideClick: false
                })
            }).catch(error => {
                Swal.fire({
                    title: "Error",
                    text: "Asegurate de tener todo los datos relleno para agendar una cita",
                    icon: "error",
                    allowOutsideClick: false
                });
            });
    }

    return (
        <div className="containerLegalSection">
            <div className="containerBannerLegal">
                <div className="bannerLegal">
                    <div
                        className="imageBannerLegal"
                        style={{
                            backgroundImage: data.length > 0 && data[0].imagen_portada_legal?.url
                                ? `url(${urlApiServerImage}${data[0].imagen_portada_legal.url})`
                                : "url('../../Assest/temporary/bannerNews.png')", // Imagen de respaldo
                            justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}
                    >
                        {data.length > 0 && data[0] ? (
                            <p className="titleBannerLegal">
                                {data.length > 0 && data[0].titulo_portada_legal ? data[0].titulo_portada_legal : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                    {infoUser.isLoged === true ? (
                        <div className="ContainerButton">
                            <div className="ButtonBanner" onClick={loggedInUser}>
                                <p className="titleButtonBanner">VINCULATE</p>
                            </div>
                        </div>
                    ) : (
                        <div className="ContainerButton">
                            <NavLink className="navLinks navLinkLegal" to="/Vinculacion">
                                <div className="ButtonBanner">
                                    <p className="titleButtonBanner">VINCULATE</p>
                                </div>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>
            <div className="containerInfoLegalSection">
                {data.length > 0 && data[0].texto_seccion_legal ? (
                    data[0].texto_seccion_legal.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>` con la clase `titleInfoLegalSection`
                                        return child.bold ? (
                                            <p key={i} className="titleInfoLegalSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textLegalSection">
                                                {child.text}
                                            </p>
                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textLegalSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textLegalSection">...</p>
                )}
            </div>
            <div className="containerFormLegalSection">
                <div className="cardFormnLegalSection">
                    <img src={GroupPerson} alt="groupPerson" className="groupPerson" />
                    <div className="containerInputsLegalSection">
                        <input
                            type="text"
                            name="names"
                            placeholder="Nombres"
                            value={name}
                            onChange={headleNames}
                            className="inputsLegalSection"
                        />
                        <input
                            type="text"
                            name="surnames"
                            placeholder="Apellidos"
                            value={surnames}
                            onChange={headleSurnames}
                            className="inputsLegalSection"
                        />
                    </div>
                    <div className="containerInputsLegalSection">
                        <input
                            type="email"
                            name="email"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={headleEmail}
                            className="inputsLegalSection"
                        />
                        <input
                            type="number"
                            name="phone"
                            placeholder="célular de contacto"
                            value={phone}
                            onChange={headlePhone}
                            className="inputsLegalSection"
                        />
                    </div>
                    <div className="containerInputsLegalSection">
                        <input
                            type="text"
                            name="currentPosition"
                            placeholder="Cargo actual"
                            value={currentPosition}
                            onChange={headleCurrentPosition}
                            className="inputsLegalSection"
                        />
                    </div>
                    <div className="containerInputsEndLegalSection">
                        <div className="">
                            <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                Fecha para la cita
                            </p>
                            <input
                                type="date"
                                name="appointment"
                                placeholder="Fecha para la cita"
                                value={appointment}
                                onChange={headleAppointment}
                                className="inputsLegalSection elongatedInputs"
                            />
                        </div>
                        <textarea
                            name="explains"
                            placeholder="Explica las razones:"
                            value={explains}
                            onChange={headleExplains}
                            className="TextareaLegalSection"
                        />
                    </div>
                    <div className="buttonFormLegal" onClick={postFormLegal}>
                        <p className="textFormLegal">ENVIAR</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Legal;
